import { createFileRoute } from '@tanstack/react-router'
import { Appointments } from '@/features/appointments'
import { redirectBsohtakDoctor } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/appointments/')({
  beforeLoad: redirectBsohtakDoctor('/my-missions'),
  component: Appointments,
})
